import { Field, Form, Formik } from 'formik';
import { InputType } from '../../../../Common/FormFields/InputType';
import { Typography } from '@material-ui/core';
import Box from '@mui/material/Box';
import RoundButton from '../../../../Common/RoundButton';
import ErrorMessage from '../../../../Common/ErrorMessage';
import { useState } from 'react';
import { ERROR_MESSAGE_TRUE } from '../../../../utils/placeHolderString';

export default function PersonalSecondForm({
  initialValues,
  validationSchema,
  onSubmitHandle,
  onChangeField,
  error,
  addressAccess,
  pinCodeAccess,
  enterKeyPress,
  formikRef,
}: any) {
  const [message, setMessage] = useState<string>('');
  const accessed = () => {
    setMessage(ERROR_MESSAGE_TRUE);
  };
  const NotAccessible = () => {};
  return (
    <>
      <div style={{ marginBottom: '10px' }}>
        <Box>
          <Formik
            validateOnMount={true}
            innerRef={formikRef}
            enableReinitialize={true}
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(value) => onSubmitHandle(value)}
          >
            {({ handleSubmit, values, touched, errors }) => (
              <Form>
                {message !== '' && <ErrorMessage text={message} />}
                <div>
                  <Field
                    component={InputType}
                    placeholder='current address'
                    name='address'
                    value={values?.address}
                    onChange={onChangeField}
                    readOnly={addressAccess}
                    className={
                      addressAccess === true
                        ? 'readOnly'
                        : 'withIcon inputAddress'
                    }
                    onClick={
                      addressAccess === true
                        ? () => accessed()
                        : () => NotAccessible()
                    }
                    onKeyPress={enterKeyPress}
                  />
                  <Field
                    component={InputType}
                    placeholder='pin code'
                    name='pincode'
                    type='number'
                    value={values?.pincode}
                    onChange={onChangeField}
                    maxLength={6}
                    readOnly={pinCodeAccess}
                    className={
                      pinCodeAccess === true
                        ? 'readOnly'
                        : 'withIcon inputPincode'
                    }
                    onClick={
                      pinCodeAccess === true
                        ? () => accessed()
                        : () => NotAccessible()
                    }
                    onKeyPress={enterKeyPress}
                  />
                </div>
                {error && <ErrorMessage text={error} />}
                <Box sx={{ mt: 4 }}>
                  <RoundButton title='Continue' type='submit' />
                </Box>
              </Form>
            )}
          </Formik>
        </Box>
      </div>
    </>
  );
}